export default __webpack_public_path__ + "static/media/joana.a655b153.jpeg";